import { createGenericTypes, createGenericActions } from 'utils'

export const getCategoriesTypes = createGenericTypes('GET_CATEGORIES')
export const getCategoriesActions = createGenericActions(getCategoriesTypes)
